import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton'
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },
  profilePicture: {
    width: '18.5vw',
    height: '12.826vw',
    borderRadius: 16,
    marginBottom: 16
  },
  input: {
    marginBottom: 16,
    height: '50px',
    maxWidth: 440
  },
  title: {
    maxWidth: 220,
    marginBottom: 16,
    height: 30
  }
}))

const ProfileFormSkeleton: React.FC = () => {
  const classes = useStyles()
  return (
    <>
      <Skeleton animation="wave" variant="rect" className={classes.title} />
      <Skeleton animation="wave" variant="rect" className={classes.profilePicture} />
      <Skeleton animation="wave" variant="rect" className={classes.input} />
      <Skeleton animation="wave" variant="rect" className={classes.input} />
      <Skeleton animation="wave" variant="rect" className={classes.input} />
    </>
  );
}

export default ProfileFormSkeleton;